import {greyishBlue100} from "assets/jss/main";
import ActionButton from "./ActionButton";

export default function ActionPanel({ activeTab, onActionClick, selectedCount }) {
    if (!activeTab || !activeTab.actions) {
        return null;
    }

    return (
        <div style={{
            backgroundColor: "#f1f3fb",
            borderRadius: "12px",
            padding: "16px 20px",
            border: `1px solid ${greyishBlue100}`,
        }}>
            <p style={{
                fontSize: "11px", fontWeight: "700",
                color: "#4338ca", letterSpacing: "0.07em",
                marginBottom: "12px", marginTop: 0,
            }}>
                {activeTab.sectionLabel}
            </p>
            <div style={{display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "10px"}}>
                {activeTab.actions.map((action) => (
                    <ActionButton
                        key={action.id}
                        icon={action.icon}
                        label={action.label}
                        onClick={() => onActionClick()}
                        selectedCount={selectedCount}
                    />
                ))}
            </div>
            <p style={{fontSize: "12px", color: "#9ca3af", margin: 0}}>
                Sélectionnez des produits pour appliquer une action en masse
            </p>
        </div>
    );
}
